/* Delivery estimate (replaces Simesy EDD). Data from data-* attributes rendered by snippets/delivery-estimate.liquid. */
(function () {
  var DAYS = ['nedelja', 'ponedeljak', 'utorak', 'sreda', 'četvrtak', 'petak', 'subota'];
  var DAY_NAMES = ['Nedelja', 'Ponedeljak', 'Utorak', 'Sreda', 'Četvrtak', 'Petak', 'Subota'];
  var MONTHS = ['Januar', 'Februar', 'Mart', 'April', 'Maj', 'Jun', 'Jul', 'Avgust', 'Septembar', 'Oktobar', 'Novembar', 'Decembar'];

  function nowIn(tz) {
    var p = {};
    new Intl.DateTimeFormat('en-GB', { timeZone: tz, year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', minute: '2-digit', second: '2-digit', hourCycle: 'h23' })
      .formatToParts(new Date()).forEach(function (x) { p[x.type] = x.value; });
    return { y: +p.year, m: +p.month, d: +p.day, h: +p.hour, mi: +p.minute, s: +p.second };
  }
  function ymd(dt) { return dt.getUTCFullYear() + '-' + String(dt.getUTCMonth() + 1).padStart(2, '0') + '-' + String(dt.getUTCDate()).padStart(2, '0'); }
  function addDay(dt) { return new Date(dt.getTime() + 86400000); }
  function isWork(dt, days, hol) { return days.indexOf(DAYS[dt.getUTCDay()]) > -1 && hol.indexOf(ymd(dt)) === -1; }
  function nextWork(dt, days, hol) { var guard = 0; while (!isWork(dt, days, hol) && guard++ < 60) dt = addDay(dt); return dt; }
  function addWork(dt, n, days, hol) { var guard = 0; while (n > 0 && guard++ < 200) { dt = addDay(dt); if (isWork(dt, days, hol)) n--; } return dt; }
  function label(dt) { return DAY_NAMES[dt.getUTCDay()] + ', ' + dt.getUTCDate() + ' ' + MONTHS[dt.getUTCMonth()]; }
  function pad(n) { return String(n).padStart(2, '0'); }
  function esc(t) { var d = document.createElement('div'); d.textContent = t; return d.innerHTML; }

  function render(el) {
    var tz = el.dataset.tz || 'Europe/Belgrade';
    var cut = (el.dataset.cutoff || '23:59').split(':');
    var shipDays = (el.dataset.shipDays || '').split(',').filter(Boolean);
    var delDays = (el.dataset.delDays || '').split(',').filter(Boolean);
    var hol = (el.dataset.holidays || '').split(',').filter(Boolean);
    var n = nowIn(tz);
    var today = new Date(Date.UTC(n.y, n.m - 1, n.d));
    var secsNow = n.h * 3600 + n.mi * 60 + n.s;
    var secsCut = (+cut[0]) * 3600 + (+cut[1]) * 60 + 59;
    var orderDay = today;
    var left = secsCut - secsNow;
    if (left <= 0) { orderDay = addDay(today); left += 86400; }
    var shipStart = nextWork(orderDay, shipDays, hol);
    var shipMin = addWork(shipStart, +el.dataset.shipMin || 0, shipDays, hol);
    var shipMax = addWork(shipStart, +el.dataset.shipMax || 0, shipDays, hol);
    var delMin = addWork(shipMin, +el.dataset.delMin || 0, delDays, hol);
    var delMax = addWork(shipMax, +el.dataset.delMax || 0, delDays, hol);

    var h = Math.floor(left / 3600), m = Math.floor((left % 3600) / 60), s = left % 60;
    var timer = (el.dataset.timer || '{sati}:{minuta}:{sekundi}').replace('{sati}', pad(h)).replace('{minuta}', pad(m)).replace('{sekundi}', pad(s));
    var l1 = el.querySelector('[data-de-line1]'), l2 = el.querySelector('[data-de-line2]');
    if (l1) l1.innerHTML = esc(el.dataset.msg1 || '').replace('{odbrojavanje}', '<strong>' + esc(timer) + '</strong>');
    if (l2) l2.innerHTML = esc(el.dataset.msg2 || '').replace('{datum_od}', '<strong>' + esc(label(delMin)) + '</strong>').replace('{datum_do}', '<strong>' + esc(label(delMax)) + '</strong>');
    var d1 = el.querySelector('[data-de-d1]'), d2 = el.querySelector('[data-de-d2]'), d3 = el.querySelector('[data-de-d3]');
    if (d1) d1.textContent = label(orderDay);
    if (d2) d2.textContent = shipMin.getTime() === shipMax.getTime() ? label(shipMin) : label(shipMin) + ' - ' + label(shipMax);
    if (d3) d3.textContent = label(delMin) + ' - ' + label(delMax);
  }

  function init() {
    var els = document.querySelectorAll('[data-delivery-estimate]');
    if (!els.length) return;
    els.forEach(render);
    setInterval(function () { els.forEach(render); }, 1000);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
